<template>
  <div class="card">
    <div class="card-header">
      <h5>Sales Report</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Departure Date Range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="From Date"
                id="departureDateStart"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="salesreport.departureDateStart"
                button-color="#ec391e"
                :only-date="true"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
              />
              <small class="text-danger" v-if="errors.departure_start">{{ errors.departure_start }}</small>
            </div>
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="To Date"
                id="departureDateEnd"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="salesreport.departureDateEnd"
                button-color="#ec391e"
                :only-date="true"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
                :min-date="salesreport.departureDateStart"
              />
              <small class="text-danger" v-if="errors.departuare_end">{{ errors.departuare_end }}</small>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <h6>Booking Date Range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="From Date"
                id="bookingDateStrt"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="salesreport.bookingDateStart"
                button-color="#ec391e"
                :only-date="true"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
              />
              <small class="text-danger" v-if="errors.booking_start">{{ errors.booking_start }}</small>
            </div>
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="To Date"
                id="bookingDateEnd"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="salesreport.bookingDateEnd"
                button-color="#ec391e"
                color="#ec391e"
                :only-date="true"
                style="border: 1px solid #DFE5F9"
                :min-date="salesreport.bookingDateStart"
              />
              <small class="text-danger" v-if="errors.booking_end">{{ errors.booking_end }}</small>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">
              <label for="salesreport.tourname" class="form-label">Tour Name</label> 
              <v-select
                :options="tours"
                label="name"
                class="m-0"
                id="tour"
                index="id"
                v-model="salesreport.tourname"
              />
            </div>
            <div class="col-md-6">
              <label for="tour_type" class="form-label">Tour Type</label>
              <v-select
                :options="tourTypes"
                label="name"
                class="m-0"
                id="tour_type"
                index="id"
                v-model="salesreport.tourtype"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <label for="checkbox" class="form-label">Include Confirmed/Paid Bookings</label>
              <br>
              <label class="switch">
                  <input id="checkbox" v-model="salesreport.includeConfirmed" type="checkbox" @change="checkSwitch('confirmed_paid')"/>
                  <span class="switch__slider"></span>
              </label>
            </div>
            <div class="col-md-4">
              <label for="checkbox" class="form-label">Include Only Cancelled Booking</label>
              <br>
              <label class="switch">
                  <input v-model="salesreport.includeCancelled" id="checkbox" type="checkbox" @change="checkSwitch('cancelled')"/>
                  <span class="switch__slider"></span>
              </label>
            </div>
            <div class="col-md-4">
              <label for="checkbox" class="form-label">Include Only Cancelled Pending</label>
              <br>
              <label class="switch">
                  <input v-model="salesreport.includeCancelledPending" id="checkbox" type="checkbox" @change="checkSwitch('cancelled_pending')"/>
                  <span class="switch__slider"></span>
              </label>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer align-items-right">
      <button type="submit" class="button" v-on:click="getSalesReport">
        Generate report
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "SalesReportFields",
  data() {
    return {
      salesreport: {
        includeConfirmed : true,
        includeCancelled : false,
        includeCancelledPending: false,
        report_type:'confirmed'
      },
      errors: {
        departure_start:null,
        departuare_end:null,
        booking_start:null,
        booking_end:null,
      },
      reportUnavailable: false,
      generatingReport: false,
      tourTypes: [],
    };
  },
  props:{
    tours: Array,
    reportVersion: {
      type: String,
      default: 'v1',
      required: true,
      validator: (value) => {
        return ['v1', 'v2'].includes(value);
      }
    },
  },
  mounted() {
    this.getTourType()
  },
  methods:{
    getSalesReport()
    {
      this.validateFields()
          .then((response) => {
            if (response) {
              this.$store.dispatch("setLoadStatus");
              let url = (this.reportVersion == 'v2') ? this.$api + 'reports/v2/generate-salesreport' : this.$api + 'reports/salesreport';

              axios({
                method:'post',
                url,
                responseType:'arraybuffer',
                data: {
                  departureDateStart: this.salesreport.departureDateStart,
                  departureDateEnd: this.salesreport.departureDateEnd,
                  tour_name: this.salesreport.tourname,
                  bookingDateStart: this.salesreport.bookingDateStart,
                  bookingDateEnd: this.salesreport.bookingDateEnd,
                  tour_type: this.salesreport.tourtype,
                  report_type: this.salesreport.report_type,
                  include_cancelled: (this.salesreport.includeCancelled) ? 'yes' : 'no',
                  include_confirmed : (this.salesreport.includeConfirmed) ? 'yes' : 'no',
                  include_cancelled_pending  : (this.salesreport.includeCancelledPending) ? 'yes' : 'no',
                },
                headers:{
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')          
                }
              })
              .then((response) =>{
                this.$store.dispatch('setLoadStatus')
                let blob = new Blob([response.data], { type:'application/xlsx' } );
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Sales-Report.xlsx';
                link.click();
              })
                .catch((error) => {
                  this.$store.dispatch('setLoadStatus')
                  this.$notify({
                    type: 'error',
                    title: error.message
                  });
              });
            }
          })
          .catch(error => console.log(error))

    },
    getTourType() {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/tour-type', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.tourTypes = response.data;
      })
    },
    validateFields(){

      let This = this
      return new Promise((resolve, reject) => {

        let errorCount = 0;

        // Departure Dates validation
        if(This.salesreport.departureDateStart && !This.salesreport.departureDateEnd) {
          This.errors.departuare_end = "Please select a valid departure to date"
          errorCount +=1
        }else if(This.salesreport.departureDateEnd && !This.salesreport.departureDateStart){
          This.errors.departure_start = "Please select a valid departure from date"
          errorCount +=1
        }else{
          This.errors.departuare_end = null
          This.errors.departure_start = null
        }

        // Booking Dates validation 
        if(This.salesreport.bookingDateStart && !This.salesreport.bookingDateEnd) {
          This.errors.booking_end = "Please select a valid booking to date"
          errorCount +=1
        }else if(This.salesreport.bookingDateEnd && !This.salesreport.bookingDateStart){
          This.errors.booking_start = "Please select a valid booking from date"
          errorCount +=1
        }else{
          This.errors.booking_end = null
          This.errors.booking_start = null
        }
        
        // Check for Departure date and Booking date
        if ( !This.salesreport.departureDateStart && !This.salesreport.bookingDateStart) 
        {
          This.errors.departure_start = "Please select departure date or booking date"
          This.errors.booking_start = "Please select booking date or departure date"

          errorCount +=1
        }else{
          This.errors.departure_start = null
          This.errors.booking_start = null
        }


        if(errorCount == 0 ){
          resolve(true)
        }else{
          reject(true)
        }

      })
    },
    checkSwitch(current_switch) {
      switch (current_switch) {
        case 'confirmed_paid':
          if (this.salesreport.includeConfirmed) {
            this.salesreport.includeCancelledPending = false
            this.salesreport.report_type = 'confirmed'
          }
          break;
        case 'cancelled':
          if (this.salesreport.includeCancelled) {
            this.salesreport.includeCancelledPending = false
            this.salesreport.report_type = 'cancelled'
          }
          break;
        case 'cancelled_pending':
          if (this.salesreport.includeCancelledPending) {
            this.salesreport.includeCancelled = false
            this.salesreport.includeConfirmed = false
            this.salesreport.report_type = 'cancelled_pending'
          }
          break;
      
        default:
          break;
      }
    }
  }
};
</script>